import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import api from '../services/api';
import Breadcrumbs from '../components/Breadcrumbs';
import { FaTv } from 'react-icons/fa';
import './Medios.css';

const DEFAULT_TV_EMBED_URL = process.env.REACT_APP_TV_IPIALES_EMBED_URL || 'https://server.asilivehd.com/hybrid-stream-video-widget/tvipiales';

const MediosTv = () => {
  const { data: config = {} } = useQuery({
    queryKey: ['configuracion'],
    queryFn: async () => {
      try {
        const res = await api.get('/configuracion');
        return res.data || {};
      } catch {
        return {};
      }
    },
    staleTime: 5 * 60 * 1000,
  });
  const tvEmbedUrl = (config.tv_ipiales_embed_url?.valor?.trim()) || DEFAULT_TV_EMBED_URL;

  return (
    <div className="medios-page medios-tv-page">
      <Breadcrumbs />
      <section className="tv-hero-section tv-hero-section-full">
        <div className="tv-hero-inner">
          <h1 className="tv-hero-title"><FaTv /> TV Ipiales en Vivo</h1>
          <p className="tv-hero-description">Transmisión en vivo de TV Ipiales</p>
          <div className="tv-hero-embed">
            <iframe
              src={tvEmbedUrl}
              title="TV Ipiales en Vivo"
              className="tv-hero-iframe"
              allowFullScreen
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
            />
          </div>
          <div className="tv-hero-actions">
            <a
              href="/tv-ipiales-en-vivo"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary tv-link-btn"
            >
              <FaTv /> Abrir en pantalla completa
            </a>
            <Link to="/medios" className="btn btn-secondary tv-link-btn" style={{ marginLeft: '0.75rem' }}>
              ← Volver a Medios
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MediosTv;
